export default {
  namespaced: true,
  state() {
    return {
      companyName: {},
      selectedTask: [],
      taskMonth: null,
      taskYear: null,
      selectedInvoice: [],
      folderLevelName: [],
    };
  },
  mutations: {
    setCompanyName(state, payload) {
      state.companyName = payload;
    },
    setSelectedTask(state, payload) {
      console.log(payload);
      state.selectedTask = payload;
    },
    setTaskDate(state, payload) {
      state.taskMonth = payload.month;
      state.taskYear = payload.year;
    },
    setSelectedInvoice(state, payload) {
      console.log(payload);
      state.selectedInvoice = payload;
    },
    setFolderLevelName(state, payload) {
      state.folderLevelName.push(payload);
    },
    popFolderLevelName(state) {
      state.folderLevelName.pop();
    },
    skipFolder(state, payload) {
      state.folderLevelName = payload;
    },
    clearFolderLevel(state) {
      state.folderLevelName = [];
    },
  },
  actions: {
    setCompanyName(context, data) {
      context.commit("setCompanyName", data);
    },
    setSelectedTask(context, data) {
      context.commit("setSelectedTask", data);
    },
    setTaskDate(context, data) {
      context.commit("setTaskDate", data);
    },
    setSelectedInvoice(context, data) {
      context.commit("setSelectedInvoice", data);
    },
    setFolderLevelName(context, data) {
      context.commit("setFolderLevelName", data);
    },
    popFolderLevelName(context, data) {
      context.commit("popFolderLevelName");
    },
    skipFolder(context, data) {
      context.commit("skipFolder", data);
    },
    clearFolderLevel(context) {
      context.commit("clearFolderLevel");
    },
  },
  getters: {
    getCompanyName(state) {
      return state.companyName;
    },
    getSelectedTask(state) {
      return state.selectedTask;
    },
    getTaskMonth(state) {
      return state.taskMonth;
    },
    getTaskYear(state) {
      return state.taskYear;
    },
    getSelectedInvoice(state) {
      return state.selectedInvoice;
    },
    getFolder(state) {
      return state.folderLevelName;
    },
  },
};
